var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'image-background-login': !_vm.auth.isLoggedIn },attrs:{"id":"app"}},[_c('app-sidebar'),_vm._v(" "),_c('div',{staticClass:"content-page",class:{ 'full-width': !_vm.auth.isLoggedIn }},[_c('div',{staticClass:"content"},[_c('app-nav'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('app-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a387509e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 7Mgk
// module chunks = 1